import Seo from "../components/Seo";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export default function DynamicPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  useEffect(() => {
    api.get(`/pages/${slug}`).then(({ data }) => {
      setPage(data);
    }).catch(() => navigate("/"));
  }, [slug, navigate]);
  if (!page) return <div className="max-w-3xl mx-auto px-4 py-24 text-center text-charcoal/50">Зареждане...</div>;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16" data-testid="dynamic-page">
      <Seo
        title={page.seo_title || page.title}
        description={page.seo_description || (page.content || "").replace(/<[^>]+>/g, "").slice(0, 160)}
        path={`/stranitsa/${page.slug}`}
      />
      <h1 className="font-serif text-4xl md:text-5xl text-navy mb-3">{page.title}</h1>
      <div className="gold-line mb-8" />
      <div className="rich-content text-charcoal/80 leading-relaxed" dangerouslySetInnerHTML={{ __html: page.content }} />
    </div>
  );
}
